import { createEnv } from '@t3-oss/env-core'
import { z } from 'zod/v4'

export function dbEnv() {
  return createEnv({
    server: {
      DATABASE_URL: z
        .string()
        .min(1)
        .refine((s) => new URL(s)),
      USE_LOCAL_DB:
        process.env.NODE_ENV === 'development'
          ? z
              .string()
              .refine((s) => s === 'true' || s === 'false')
              .transform((s) => s === 'true')
          : z
              .string()
              .refine((s) => s === 'true' || s === 'false')
              .transform((s) => s === 'true')
              .optional(),
      NODE_ENV: z.enum(['development', 'production']).optional(),
    },
    clientPrefix: 'NEXT_PUBLIC',
    client: {
      NEXT_PUBLIC_PROD_ENV: z.enum(['development', 'production', 'staging']).optional(),
    },
    runtimeEnv: process.env,
    skipValidation:
      !!process.env.CI ||
      process.env.npm_lifecycle_event === 'lint' ||
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      typeof (globalThis as any).window !== 'undefined', // Skip in browser
  })
}
